<template>
  <b-form
    v-if="show">
    <b-form-group
      id="input-group-internal-name"
      :label="$t('label.internal_name')"
      label-for="input-internal-name"
    >
      <b-form-input
        id="input-internal-name"
        v-model="form.esta_internal_name"
        type="text"
        required
      />
    </b-form-group>

    <div class="checkbox_zone">
      <b-form-group id="input-group-check-internal">
        <b-form-checkbox
          id="checkbox-is_internal"
          v-model="form.esta_is_internal"
          :value="true"
          :unchecked-value="false"
        >{{ $t("label.internal") }}</b-form-checkbox
        >
      </b-form-group>

      <b-form-group id="input-group-checks-enable">
        <b-form-checkbox
          id="checkbox-is_enable"
          v-model="form.esta_is_enable"
          :value="true"
          :unchecked-value="false"
        >{{ $t("label.active") }}</b-form-checkbox
        >
      </b-form-group>
    </div>
    <b-form-group
      id="input-group-name"
      :label="$t('label.login_esta')"
      label-for="input-name"
    >
      <b-form-input
        id="input-internal-name"
        v-model="form.esta_name"
        type="text"
        required
      />
    </b-form-group>
    <b-form-group
      id="input-group-nice-name"
      :label="$t('label.esta_display_name')"
      label-for="input-nice-name"
    >
      <b-form-input
        id="input-nice-name"
        v-model="form.esta_nice_name"
        type="text"
        required
      />
    </b-form-group>

    <b-form-group
      id="input-group-tags"
      :label="$t('label.esta_tags')"
      label-for="input-tags"
    >
      <multiselect
        v-model="form.tags"
        :options="allTags"
        :multiple="true"
        :close-on-select="false"
        :clear-on-select="false"
        :preserve-search="true"
        :preselect-first="true"
        placeholder=""
        label="tag_name"
        track-by="tag_id"/>
    </b-form-group>

    <b-form-group
      id="input-group-relativeto"
      :label="$t('label.esta_parent')"
      label-for="input-relativeto"
    >
      <b-form-select
        id="input-relativeto"
        v-model="form.parent_id"
        :options="establishments"
        value-field="esta_id"
        text-field="esta_name"
      />
    </b-form-group>

    <b-form-group
      id="input-group-lemon"
      :label="$t('label.lemon_tag')"
      label-for="input-country"
    >
      <b-form-select
        id="input-relativeto"
        v-model="form.lemon_project_tag"
        :options="allLemonTags"
        value-field="project_id"
        text-field="project_lemon_tag"
      />
    </b-form-group>


    <b-form-group
      id="input-group-address"
      :label="$t('label.address')"
      label-for="input-address"
    >
      <b-form-input
        id="input-address"
        v-model="form.esta_address"
        type="text"
      />
    </b-form-group>

    <b-form-group
      id="input-group-city"
      :label="$t('label.city')"
      label-for="input-city"
    >
      <b-form-input
        id="input-city"
        v-model="form.esta_city"
        type="text" />
    </b-form-group>

    <b-form-group
      id="input-group-postalcode"
      :label="$t('label.postal_code')"
      label-for="input-postalcode"
    >
      <b-form-input
        id="input-postalcode"
        v-model="form.esta_postalcode"
        type="number"
        maxlength="5"
      />
    </b-form-group>

    <b-form-group
      id="input-group-country"
      :label="$t('label.country')"
      label-for="input-country"
    >

      <multiselect
        id="input-country"
        v-model="form.esta_country"
        :options="countries"
        :searchable="false"
        :close-on-select="true"
        :show-labels="false"/>
    </b-form-group>

    <b-form-group
      id="input-group-email"
      :label="$t('label.email')"
      label-for="input-email"
    >
      <b-form-input
        id="input-email"
        v-model="form.esta_email"
        type="email"
      />
    </b-form-group>

    <b-form-group
      id="input-group-phone"
      :label="$t('label.phone')"
      label-for="input-phone"
    >
      <b-form-input
        id="input-phone"
        v-model="form.esta_phone"
        type="number"
        maxlength="10"
      />
    </b-form-group>
  </b-form>
</template>

<script>
import Multiselect from 'vue-multiselect';
import { getAllEstablishment } from '../../services/establishment';
import { getAllHelpProjects } from '../../services/lemon';
import { getAllTag } from '../../services/tag';

export default {
  name: 'FormEstablishment',
  components: { Multiselect },
  props: {
    estaInfo: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      form: {
        esta_id: null,
        esta_internal_name: '',
        esta_name: '',
        esta_nice_name: '',
        parent_id: null,
        esta_address: '',
        esta_city: '',
        esta_postalcode: '',
        esta_country: '',
        esta_email: '',
        esta_phone: '',
        esta_is_internal: false,
        esta_is_enable: false,
        tags: [],
        lemon_project_tag: [],
      },
      countries: ['France', 'Royaume-Uni', 'Espagne', 'Italie'],
      show: true,
      establishments: [],
      allTags: [],
      value: null,
      allLemonTags: [],
    };
  },
  async mounted() {
    this.form = JSON.parse(JSON.stringify(this.estaInfo));
    this.form.parent_id = this.estaInfo.parent.esta_id;
    this.establishments = await getAllEstablishment();
    this.allTags = await getAllTag();
    this.allLemonTags = await getAllHelpProjects();
    if (this.estaInfo.lemon_project_tag) {
      this.form.lemon_project_tag = this.allLemonTags.filter(tag => this.estaInfo.lemon_project_tag === tag.project_lemon_tag)[0].project_id;
    } else {
      this.estaInfo.lemon_project_tag = 1;
    }
  }
};
</script>

<style scoped>
.checkbox_zone {
  display: flex;
}

#input-group-check-internal {
  margin-right: 1rem;
}
</style>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
